import type { CSSProperties } from "react";
import { TagIntent } from "widgets";

import { EVENT_STATUS } from "@/settings/settings.ts";

export const getEventTagIntent = (status?: string): TagIntent => {
  switch (status) {
    case EVENT_STATUS.QUEUED:
      return TagIntent.Primary;
    case EVENT_STATUS.RUNNING:
      return TagIntent.Warning;
    case EVENT_STATUS.ERROR:
    case EVENT_STATUS.TERMINATED:
      return TagIntent.Danger;
    case EVENT_STATUS.COMPLETED:
      return TagIntent.Success;
    default:
      // INITIALIZING
      return TagIntent.Secondary;
  }
};
export const getTagIntentColor = (intent?: TagIntent): CSSProperties["color"] => {
  switch (intent) {
    case TagIntent.Primary:
      return "hsl(206 37% 44%)";
    case TagIntent.Warning:
      return "hsl(43 100% 46%)";
    case TagIntent.Danger:
      return "hsl(345 77% 40%)";
    case TagIntent.Success:
      return "hsl(93 41% 51%)";
    default:
      // TagIntent.Secondary;
      return "hsl(240 1% 33%)";
  }
};
